module.exports = __webpack_public_path__ + "static/media/grid-view.7d8ab503.svg";